
import { device } from '../Constants/Constants';
import { v4 as uuidv4 } from 'uuid';
import config from "src/config";

const CryptoJS = require('crypto-js');
const forge = require('node-forge');
const SECRET = config.SECRET;
const bytesLenght = 16

export const decryptClientData = async context => decryptDataAesGcm(context.aesKey, context.iv, context.encryptedData);

export const decryptPrevalidateData = async context => decryptDataAesGcm(context.aesKey, context.ivPrevalidate, context.encryptedDataPrevalidate);

export const generateBfKey = async context => {
  const aesKey = generateAESkey(context);
  const data = {
    key: aesKey,
    device: JSON.stringify(device).replace(/\s/g, ""),
    desktop: context.deviceType
  };
  const dataStr = JSON.stringify(data);

  if (aesKey) {
    const jwe = await generateJWE(dataStr, context.bffKey);
    return { jwe, aesKey, dataStr };
  } else {
    return { error: true };
  }
};

export const generateBfKeyManual = async (context, dataReq) => {
  const aesKey = generateAESkey(context);
  const data = {
    key: aesKey,
    device: JSON.stringify(device).replace(/\s/g, ""),
    ...dataReq
  };
  const dataStr = JSON.stringify(data);
  if (aesKey) {
    const jwe = await generateJWE(dataStr, context.bffKey);
    return { jwe, aesKey, dataStr };
  } else {
    return { error: true };
  }
};

export const refreshBfKey = async context => {
  const jwe = await generateJWE(context.dataStr, context.bffKey);
  return { jwe };
};

const decryptDataAesGcm = (aesKey, ivData, encryptedData) => {
  const hashByKey = aesKey.toUpperCase().slice(0, bytesLenght);
  const buffer = Buffer.from(hashByKey, 'utf-8');
  const secretKeyString = buffer.toString('base64');

  const key = forge.util.decode64(secretKeyString);
  const iv = forge.util.decode64(ivData);

  const encryptedBytes = forge.util.decode64(encryptedData);
  const decipher = forge.cipher.createDecipher('AES-GCM', key);
  decipher.start({
      iv: iv,
      tagLength: 128,
      tag: encryptedBytes.slice(-bytesLenght)
  });

  decipher.update(forge.util.createBuffer(encryptedBytes.slice(0, -bytesLenght)));
  const pass = decipher.finish();
  if(pass) {
      const resultData = (hextostring(decipher.output.toHex()))
      return JSON.parse(resultData)
  }else{
      return {error: true}
  }
}

const generateAESkey = context => {
  try{
      let secretKeyStringFormat = context.sessionId + context.clientId +  uuidv4() +  uuidv4();
      secretKeyStringFormat = secretKeyStringFormat.replace(/[-_.]/g, "");
      return generateHash(secretKeyStringFormat)
  }catch(e){
      return null
  }
}

const generateHash = text => {
  const hash = CryptoJS.SHA256(text);
  const hashHex = hash.toString(CryptoJS.enc.Hex);
  return hashHex.toUpperCase();
}

export const generateJWE = async (stringValue, _publicKey) => {
  const { JWK, JWE } = require('node-jose');
  const publicKeyPEM = `
  -----BEGIN PUBLIC KEY-----
  ${_publicKey}
  -----END PUBLIC KEY-----
  `;
  const publicKey = await JWK.asKey(publicKeyPEM, "pem");
  const buffer = Buffer.from(stringValue);
  return JWE.createEncrypt({ format: 'compact', fields: { alg: "RSA-OAEP-256", enc: "A256GCM" }}, publicKey)
  .update(buffer).final();
}

const hextostring = hex => {
  let str = '';
  const space = 2
  for (let i = 0; i < hex.length; i += space) {
      const v = parseInt(hex.substr(i, space), 16);
      if (v){str += String.fromCharCode(v)};
  }
  return str;
}

const encryptDataAesGcm = (context, data) => {
  let secretKeyStringFormat = context.sessionId + context.clientId + SECRET;
  secretKeyStringFormat = secretKeyStringFormat.replace(/[-_.]/g, "");

  const hashByKey = generateHash(secretKeyStringFormat).toUpperCase().slice(0, bytesLenght);
  const buffer = Buffer.from(hashByKey, 'utf-8');
  const secretKeyString = buffer.toString('base64');

  const key = forge.util.decode64(secretKeyString);
  const iv = forge.random.getBytesSync(bytesLenght);

  const cipher  = forge.cipher.createCipher('AES-GCM', key);
  cipher.start({
      iv: iv
  });

  const base64data = JSON.stringify(data)
  cipher.update(forge.util.createBuffer(base64data));
  cipher.finish();
  
  const encrypted = cipher.output.getBytes();
  const tag = cipher.mode.tag.getBytes();
  
  return {
      data: forge.util.encode64(encrypted), 
      iv: forge.util.encode64(iv),
      tag: forge.util.encode64(tag)
  };
}

const decryptDataAesGcmOwn = context => {
  let secretKeyStringFormat = context.sessionId + context.clientId + SECRET;
  secretKeyStringFormat = secretKeyStringFormat.replace(/[-_.]/g, "");

  const hashByKey = generateHash(secretKeyStringFormat);
  const buffer = Buffer.from(hashByKey, 'utf-8');
  const secretKeyString = buffer.toString('base64');

  const key = forge.util.decode64(secretKeyString);
  const iv = forge.util.decode64(context.iv);
  const tag = forge.util.decode64(context.tag);
  const encryptedBytes = forge.util.decode64(context.encryptedData);
  const decipher = forge.cipher.createDecipher('AES-GCM', key);
  decipher.start({
      iv: iv,
      tag: tag
  });

  decipher.update(forge.util.createBuffer(encryptedBytes));
  const pass = decipher.finish();
  if(pass) {
      const resultData = (hextostring(decipher.output.toHex()))
      return JSON.parse(resultData)
  }else{
      return {error: true}
  }
}